/* eslint no-underscore-dangle: ["error", { "allow": ["_links", "_items", "_id"] }] */
import queryString from 'query-string';
import _ from 'lodash';
import { reducer as jsonApiReducer } from '@keypr/redux-json-api';
import {
  API_READ,
  API_CREATED,
  API_UPDATED,
  API_READ_FAILED,
  API_CREATE_FAILED,
  API_UPDATE_FAILED,
} from '@keypr/redux-json-api/lib/constants';
import {
  API_CLEAR,
  RESET_AFFILIATE,
  USER_LOGOUT,
} from '../types';

const nextActionTypes = [
  API_READ,
  API_READ_FAILED,
];

const lastActionTypes = [
  API_CREATED,
  API_UPDATED,
  API_CREATE_FAILED,
  API_UPDATE_FAILED,
];

const defaultState = {
  lastAction: {
    configType: null,
    id: null,
  },
  nextAction: {},
  isCreating: 0,
  isReading: 0,
  isUpdating: 0,
  isDeleting: 0,
  endpoint: {
    host: null,
    path: null,
    headers: {
      'Content-Type': 'application/vnd.api+json',
      Accept: 'application/vnd.api+json',
    },
  },
};

const api = (state = defaultState, action) => {
  let configType = state.lastAction.configType;
  if (action.type.indexOf('API_') !== -1 && action.type.indexOf('API_LOADED_') === -1) {
    if (action.payload && action.payload.options) {
      configType = action.payload.options.configType || null;
    }
  }
  if (action.type.indexOf('API_LOADED_') !== -1 && action.payload) {
    const newState = Object.assign({}, state);
    if (!newState[action.payload.type || '-not-set-']) {
      newState[action.payload.type || '-not-set-'] = {};
      newState[action.payload.type || '-not-set-'].data = [];
    }
    return newState;
  } else if (action.type === API_CLEAR) {
    const { payload: { resource: { type } } } = action;
    const newState = Object.assign({}, state);
    if (_.has(newState, type)) {
      delete newState[type];
    }
    return newState;
  } else if (action.type === RESET_AFFILIATE) {
    return {
      lastAction: {
        configType,
        id: null,
      },
      nextAction: {},
      isCreating: 0,
      isReading: 0,
      isUpdating: 0,
      isDeleting: 0,
      user: (state.user) ? Object.assign({}, state.user) : undefined,
      affiliate: (state.affiliate) ? Object.assign({}, state.affiliate) : undefined,
      endpoint: (state.endpoint) ? Object.assign({}, state.endpoint) : undefined,
    };
  } else if (action.type === USER_LOGOUT) {
    return {
      lastAction: {
        configType,
        id: null,
      },
      nextAction: {},
      isCreating: 0,
      isReading: 0,
      isUpdating: 0,
      isDeleting: 0,
      endpoint: (state.endpoint) ? Object.assign({}, state.endpoint) : undefined,
    };
  }
  let lastAction = { configType, id: null };
  let nextAction = _.has(state, 'nextAction') ? state.nextAction : {};
  if (lastActionTypes.indexOf(action.type) !== -1) {
    let id = null;
    if (action.payload.resource.id) {
      id = action.payload.resource.id;
    }
    if (action.payload.resource._id) {
      id = action.payload.resource._id;
    }
    lastAction = {
      configType,
      id,
    };
  }
  if (nextActionTypes.indexOf(action.type) !== -1) {
    let params = { page: null };
    const addNextAction = {};
    if (action.payload.resource) {
      const next = _.get(action, 'payload.resource.links.next');
      const nextHref = _.get(action, 'payload.resource._links.next.href');
      if (next) {
        params = queryString.parse(next.split('?')[1]);
      }
      if (nextHref) {
        params = queryString.parse(nextHref.split('?')[1]);
      }
    }
    addNextAction[configType] = params.page || null;
    nextAction = Object.assign({}, nextAction, addNextAction);
  }
  const apiReducerOutput = jsonApiReducer(state, action);
  return Object.assign({}, apiReducerOutput, {
    lastAction,
    nextAction,
  });
};

export default api;



// WEBPACK FOOTER //
// ./src/state/reducers/api.js